const spkStationaer = {
  erstedaten: {
    anschrift_tt: `<h2>Anschrift</h2>
        <p>Bitte geben Sie hier die Adresse ein, für welche Sie die Glasversicherung abschließen möchten.</p>`,
    anschrift_sub: 'Bitte geben Sie hier die Adresse ein, für welche Sie die Glasversicherung'
        + ' abschließen möchten.',
    wohnflaeche_tt: `<h2>Wohnfläche</h2>
        <p>Anhand der Wohnfläche berechnen wir Ihren Beitrag.</p>
        <p>Bitte geben Sie hier die Wohnfläche der zu versichernden Wohnung/des zu versichernden Hauses ein</p>`,
    typ_tt: `<h2>Wohnung oder Haus?</h2>
        <p>Geben Sie hier bitte an, ob Sie die Verglasung in einer Wohnung oder einem Haus versichern möchten.</p>`,
    versicherbar: '',
  },
};

export default spkStationaer;
